import gql from "graphql-tag"
import { useMutation } from "react-apollo"

const UPDATE_CDN_CONFIG = gql`
  mutation setCDNConfig(
    $siteId: UUID!
    $serviceId: String!
    $serviceName: String!
    $accountName: String
    $vendor: CdnVendor!
  ) {
    setCDNConfig(
      siteId: $siteId
      serviceId: $serviceId
      serviceName: $serviceName
      accountName: $accountName
      vendor: $vendor
    ) {
      success
      message
    }
  }
`

export const useCreateIntegration = vendor => {
  const [createIntegrationMutation, { loading }] = useMutation(
    UPDATE_CDN_CONFIG
  )

  const createIntegration = (siteId, serviceId, serviceName, accountName) =>
    createIntegrationMutation({
      variables: {
        siteId,
        serviceId,
        serviceName,
        accountName,
        vendor,
      },
    })

  return [createIntegration, { loading }]
}
